import { render, staticRenderFns } from "./liabilityPbTable.vue?vue&type=template&id=ce297d50"
import script from "./liabilityPbTable.vue?vue&type=script&lang=js"
export * from "./liabilityPbTable.vue?vue&type=script&lang=js"
import style0 from "./liabilityPbTable.vue?vue&type=style&index=0&id=ce297d50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports